import React, { useState, useCallback } from 'react';

import { App, Spin, Typography } from 'antd';

import ActionCollapse from 'v2/components/Shared/QuickView/ActionCollapse';
import type { IFiscalDocuments, ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingService from 'v2/services/shopping/product';

import { Icon } from '@eduzz/ui-antd-theme';

const FiscalDocument = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const { message } = App.useApp();
  const [loadingDocuments, setLoadingDocument] = useState<boolean>(false);
  const [fiscalDocuments, setFiscalDocuments] = useState<any[]>([]);

  const handleClickFiscalDocuments = useCallback(
    async (invoiceId: string) => {
      setLoadingDocument(true);
      shoppingService.loadFiscalDocuments(invoiceId).subscribe(
        res => {
          setFiscalDocuments(res.data);
          setLoadingDocument(false);
        },
        () => {
          setLoadingDocument(false);
          message.error('Não foi possível carregar as notas fiscais.');
        }
      );
    },
    [message]
  );

  return (
    <ActionCollapse
      title='Nota Fiscal'
      icon={<Icon.FileText size={16} />}
      onExpand={expanded => {
        if (expanded) {
          handleClickFiscalDocuments(delivery.invoice_id.toString());
        }
      }}
    >
      {loadingDocuments && <Spin />}

      {!loadingDocuments &&
        Array.isArray(fiscalDocuments) &&
        fiscalDocuments.length > 0 &&
        fiscalDocuments.map((document: IFiscalDocuments, index) => (
          <div key={'document-' + index}>
            <Typography.Link
              href={document.url}
              target='_blank'
              rel='noopener noreferrer'
              className='flex items-center gap-2 text-sm'
            >
              <Icon.File size={14} />
              <span>
                {document.title} ({document.ext.toUpperCase()})
              </span>
            </Typography.Link>
          </div>
        ))}

      {!loadingDocuments && (!Array.isArray(fiscalDocuments) || fiscalDocuments.length === 0) && (
        <Typography.Text type='secondary' className='block w-full py-4 text-center text-sm'>
          Nenhum arquivo encontrado...
        </Typography.Text>
      )}
    </ActionCollapse>
  );
};

export default FiscalDocument;
